import React from 'react';
import { Helmet } from 'react-helmet';

const MetaDecorator = ({ title, descrption, url, noindex }) => {
    return (
        <Helmet>
            { title ? <title>{title}</title> : ""}
            { descrption ? <meta name="description" content={descrption} /> : ""}
            { url ? <link rel="canonical" href={url} /> : ""}
            { noindex ? <meta name="robots" content="noindex" /> : ""}
        </Helmet>
    );
}

export default MetaDecorator;


// WEBPACK FOOTER //
// ./src/components/services/MetaDecorator.js